import ad1 from "@/assets/marquee-ads/ad-1.png";
import ad2 from "@/assets/marquee-ads/ad-2.png";
import ad3 from "@/assets/marquee-ads/ad-3.png";
import ad4 from "@/assets/marquee-ads/ad-4.png";
import ad5 from "@/assets/marquee-ads/ad-5.png";
import ad6 from "@/assets/marquee-ads/ad-6.png";
import ad7 from "@/assets/marquee-ads/ad-7.png";
import ad8 from "@/assets/marquee-ads/ad-8.png";
import ad9 from "@/assets/marquee-ads/ad-9.png";
import ad10 from "@/assets/marquee-ads/ad-10.png";

import row2_1 from "@/assets/marquee-ads/row2-1.png";
import row2_2 from "@/assets/marquee-ads/row2-2.png";
import row2_3 from "@/assets/marquee-ads/row2-3.png";
import row2_4 from "@/assets/marquee-ads/row2-4.png";
import row2_5 from "@/assets/marquee-ads/row2-5.png";
import row2_6 from "@/assets/marquee-ads/row2-6.png";
import row2_7 from "@/assets/marquee-ads/row2-7.png";

const adImagesRow1 = [ad1, ad2, ad3, ad4, ad5, ad6, ad7, ad8, ad9, ad10];
const adImagesRow2 = [row2_1, row2_2, row2_3, row2_4, row2_5, row2_6, row2_7];

const AdMarquee = () => {
  return (
    <section className="w-full py-8 md:py-12 bg-background overflow-hidden space-y-4">
      {/* First Marquee - scrolling left */}
      <div className="relative w-full">
        <div className="flex animate-marquee">
          {/* First set of images */}
          {adImagesRow1.map((img, index) => (
            <div
              key={`first-${index}`}
              className="flex-shrink-0 w-48 md:w-56 lg:w-64 mx-2"
            >
            <img
              src={img}
              alt={`Ad creative ${index + 1}`}
              loading="lazy"
              decoding="async"
              className="w-full h-auto rounded-xl object-cover"
            />
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {adImagesRow1.map((img, index) => (
            <div
              key={`second-${index}`}
              className="flex-shrink-0 w-48 md:w-56 lg:w-64 mx-2"
            >
            <img
              src={img}
              alt={`Ad creative ${index + 1}`}
              loading="lazy"
              decoding="async"
              className="w-full h-auto rounded-xl object-cover"
            />
            </div>
          ))}
        </div>
      </div>

      {/* Second Marquee - scrolling right (opposite direction) */}
      <div className="relative w-full">
        <div className="flex animate-marquee-reverse">
          {/* First set of images */}
          {adImagesRow2.map((img, index) => (
            <div
              key={`first-row2-${index}`}
              className="flex-shrink-0 w-48 md:w-56 lg:w-64 mx-2"
            >
            <img
              src={img}
              alt={`Ad creative row 2 ${index + 1}`}
              loading="lazy"
              decoding="async"
              className="w-full h-auto rounded-xl object-cover"
            />
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {adImagesRow2.map((img, index) => (
            <div
              key={`second-row2-${index}`}
              className="flex-shrink-0 w-48 md:w-56 lg:w-64 mx-2"
            >
            <img
              src={img}
              alt={`Ad creative row 2 ${index + 1}`}
              loading="lazy"
              decoding="async"
              className="w-full h-auto rounded-xl object-cover"
            />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdMarquee;
